$(function(){
    $('.product-img .product-types li').click(function(){
        $(this).addClass('active');
        $('.product-img .product-types li').not($(this)).removeClass('active');

        var itemData = $(this).attr('data-product');
        $('.product-img').find('img[data-productImg="' + itemData + '"]').show();
        $('.product-img img').not('img[data-productImg="' + itemData + '"]').hide();
    });

    $('.sizes-list li').click(function(){
        $(this).addClass('active');
        $('.sizes-list li').not($(this)).removeClass('active');

        var sizeData = $(this).attr('data-size');
        $('.available-counts').find('ul[data-counts="' +sizeData + '"]').addClass('active');
        $('.available-counts ul').not('ul[data-counts="' + sizeData + '"]').removeClass('active');

        var firstStore = $('.available-counts ul.active li:first-of-type').attr('data-wherebuy');
        $('.available-counts ul.active li:first-of-type').addClass('active');
        $('.available-counts ul li[data-wherebuy]').not('.available-counts ul.active li:first-of-type').removeClass('active');
        $('.where-buy').find('div[data-stores="' +firstStore + '"]').addClass('storeactive');
        $('.where-buy .store-list').not('div[data-stores="' + firstStore + '"]').removeClass('storeactive');
        // $('.where-buy').find('div[data-stores="' +sizeData + '"]').addClass('storeactive');
        // $('.where-buy .store-list').not('div[data-stores="' + sizeData + '"]').removeClass('storeactive');
    });

    $('.available-counts ul li[data-wherebuy]').click(function(){
        var storesData = $(this).attr('data-wherebuy');
        
        $(this).addClass('active');
        $('.available-counts ul li[data-wherebuy]').not($(this)).removeClass('active');

        $('.where-buy').find('div[data-stores="' +storesData + '"]').addClass('storeactive');
        $('.where-buy .store-list').not('div[data-stores="' + storesData + '"]').removeClass('storeactive');

        if(window.innerWidth < 768){
            var scrollStores = $('section.where-buy').offset().top - 200;
            $("html, body").animate({ scrollTop: scrollStores}, "slow");
             return false;
        }
    });

    // $('.sizes-dropdown .size-active').click(function(e){
    //     e.preventDefault();
    //     $(this).next().slideToggle('fast');
    // })
})